import { Checkbox, Form, Input, message, Radio, Spin } from 'antd';
import { Rule } from 'antd/lib/form';
// import { useEffect, useState, useRef } from 'react';
import { useEffect, useState } from 'react';
import { BankDetailsPayload, MandateLinkPayload, getNachBankDetails } from 'api/nach';
// import CancelGeneratedLinkModal from './CancelGeneratedLinkModal';
// import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useIfscValidator } from '../../hooks/useIfscValidator';
import { handleOnlyDgit } from 'features/nach/utils/handleOnlyDigit';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
// import axios from 'axios';

// import { getAccountValidationRules } from 'features/nach/utils/accountValidation';

type BankDetailsType = {
  accountNo?: string;
  AccountNumber?: string;
  IFSC: string;
  BankName: string;
  AccountType: string;
  BranchName: string;
  isEditable: boolean;
  bankCode: string;
};

type Props = {
  mandateAmount: number;
  checkedRecord: any;
  fetchedData: MandateLinkPayload;
  title?: string;
  nachBankData?: BankDetailsType;
  setNachBankData: (data: BankDetailsType) => void;
  sameAsEnach?: boolean;
  onSubmit?: (payload: any) => void;
  //form: FormInstance;
  form: any;
  nachId: number;
  enachBankData?: BankDetailsType;
  setBankCode: (code: string) => void;
  isVisibleEnach: boolean;
};

export function AutoPayDetails({
  // fetchedData,
  title,
  enachBankData,
  setNachBankData,
  nachBankData,
  sameAsEnach,
  nachId,
  isVisibleEnach,
  form,
  setBankCode,
}: Props) {
  const [bankNameList, setBankNameList] = useState<any>([]);

  const [isSameEnachChecked, setIsSameEnachChecked] = useState(false);
  // const [sameAsEnachBankData, setSameAsEnachBankData] = useState(false);
  // console.log('isEnach visible', isVisibleEnach);

  const {
    branchName,
    setIfscCode,
    ifscError,
    bankName: bankName1,
    bankCode,
    isLoading,
  } = useIfscValidator(form?.ifscCode as string);

  console.log('bankCode', bankCode);
  console.log('isfcError', ifscError);
  const [isEditable, setIsEditable] = useState(true);

  setBankCode(bankCode);

  // // FIXED: Using useRef ensures the timeout identifier survives across component re-renders
  // const validationTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // const checkAccountLengthWithBackend = (id: number, currentLength: number): Promise<{ isValid: boolean; minLength: number }> => {
  //   return new Promise((resolve) => {
  //     // Clear the previous pending timeout safely using the current ref value
  //     if (validationTimeoutRef.current) {
  //       clearTimeout(validationTimeoutRef.current);
  //     }

  //     // Set a fresh 500ms delay window to protect backend resources from key thrashing
  //     validationTimeoutRef.current = setTimeout(async () => {
  //       const url = `https://ppapiepayment.avanse.com/api/avanse/nachmodule/payment-config/validate-length?nachId=${id}&length=${currentLength}`;
  //       console.log(`[Debounced Request] Sending validation payload -> URL: ${url}`);

  //       try {
  //         const response = await axios.get(url);
  //         console.log("[API Response Success] Data received from backend:", response.data);
  //         resolve(response.data);
  //       } catch (error) {
  //         console.error("Backend validation failed during debounce cycle:", error);
  //         resolve({ isValid: true, minLength: 7 }); // Safe fallback bypass
  //       }
  //     }, 500);
  //   });
  // };

  // useEffect(() => {
  const handleNachData = (e: CheckboxChangeEvent) => {
    setIsSameEnachChecked(e.target.checked);
    if (e.target.checked) {
      // console.log({ enachBankData });
      enachBankData && setNachBankData(enachBankData);
      enachBankData && form.setFieldsValue(enachBankData);
      getNachBankDetails({ nachId: nachId }).then((res) => {
        if (res.status === 'SUCCESS') {
          console.log('bank details', nachId == 1 ? 'enach' : 'pnach');
          console.log(res.data);
          setBankNameList(res.data);
        }
      });
    } else {
      // setNachBankData()
      setBankNameList([]);
    }
  };
  // }, [fetchedData]);
  // 1. WATCHER FOR E-NACH ACCOUNT NUMBER CHANGES (SECOND TIME EDITS)
  // useEffect(() => {
  //   if (isSameEnachChecked && enachBankData) {
  //     const activeAutoPayAccount = form.getFieldValue('accountNo');
  //     const latestEnachAccount = enachBankData.accountNo || enachBankData.AccountNumber;

  //     // If the parent enach data shifted and no longer matches what this form holds, flag it!
  //     if (activeAutoPayAccount && latestEnachAccount && activeAutoPayAccount !== latestEnachAccount) {
  //       form.setFields([
  //         {
  //           name: 'accountNo',
  //           errors: ['Kindly enter the correct account number in AutoPay'],
  //         },
  //       ]);
  //     }
  //   }
  // }, [enachBankData, isSameEnachChecked, form]);
  console.log('nach id', nachId);
  console.log('Nach Bank data', nachBankData);
  // console.log('Form data', formData);

  useEffect(() => {
    form.setFieldsValue(nachBankData);
  }, [nachBankData]);

  const handleChange = () => {
    const formData = form.getFieldsValue();
    if (setNachBankData) {
      setNachBankData(formData);
    }
  };
  useEffect(() => {
    const autoFillBankAndIfsc = async () => {
      // console.log(bankNameList, bankName1);
      console.log('Bank Name 1', autoFillBankAndIfsc);
      console.log('Bank Name 1', bankName1);
      console.log('Bank name List ', bankNameList);
      console.log('', autoFillBankAndIfsc);

      const bankNameFound = bankNameList.some((item: any) => item?.bankName.includes(bankName1));

      if (!bankNameFound && bankName1 && !ifscError) {
        const messageErr =
          nachId == 1
            ? 'Ifsc code is not exist for enach banks'
            : 'Ifsc code is not exist for Autopay banks';
        message.error(messageErr);
        await form.setFieldValue('bankName', undefined);
        await form.setFieldValue('branchName', undefined);
        return;
      }
      if (bankName1 == '') {
        await form.setFieldValue('bankName', undefined);
        await form.setFieldValue('branchName', undefined);
      } else {
      }
      // await form.validateFields();
    };
    branchName && form.setFieldValue('branchName', branchName);
    bankName1 && form.setFieldValue('bankName', bankName1);
    // autoFillBankAndIfsc();
  }, [branchName, bankName1]);
  useEffect(() => {
    if (isEditable) {
      form.validateFields();
    }
  }, [isEditable]);

  useEffect(() => {
    if (ifscError)
      !isEditable &&
        form.setFields([
          {
            name: 'ifscCode',
            errors: ['Please enter a valid IFSC code'],
          },
        ]);
  }, [ifscError, isEditable]);

  const required: Rule[] = [
    {
      required: !isEditable,
      type: 'string',
    },
  ];

  return (
    <div className="mid-container" style={{ position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '5px 20px',
          marginBottom: '40px',
          backgroundColor: '#cee9e9',
        }}
      >
        <h5 style={{ marginTop: '10px' }}>{title}</h5>
      </div>
      <Spin spinning={isLoading}>
        {isVisibleEnach && (
          <Checkbox
            onChange={(value) => {
              handleNachData(value);
            }}
          >
            Same as Enach
          </Checkbox>
        )}
        <Form<BankDetailsPayload>
          form={form}
          layout="vertical"
          scrollToFirstError
          className="standard-forms"
          initialValues={nachBankData}
          onChange={handleChange}
          disabled={sameAsEnach || isSameEnachChecked}
          autoComplete="off"
        >
          <div className="row">
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'IFSC Code:'}
                  rules={[
                    ...required,
                    {
                      len: 11,
                    },
                  ]}
                  name="ifscCode"
                  className="fieldTitle"
                  initialValue={''}
                  validateStatus={ifscError ? 'error' : undefined}
                  help={ifscError ? 'Please enter a valid IFSC code!' : undefined}
                >
                  <Input
                    onChange={(e) => {
                      const upperCaseValue = e.target.value.toUpperCase();
                      setIfscCode(upperCaseValue); // Update state with uppercase value
                      form.setFieldsValue({ ifscCode: upperCaseValue });
                    }}
                    maxLength={11}
                    autoCapitalize="characters"
                    placeholder={'Enter IFSC Code'}
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>

            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'Account Number:'}
                  // required
                  initialValue={''}
                  name="accountNo"
                  className="fieldTitle"
                  rules={[
                    ...required,
                    {
                      min: 7,
                      max: 20,
                    },
                  ]}
                  style={{ marginTop: '-6px' }}
                >
                  {/* <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'Account Number:'}
                  initialValue={''}
                  name="accountNo"
                  className="fieldTitle"
                  rules={getAccountValidationRules({
                    nachId: nachId,
                    isEditable: isEditable,
                    checkLengthApi: checkAccountLengthWithBackend
                  })}
                  style={{ marginTop: '-6px' }}
                > */}
                  <Input
                    autoComplete="off"
                    onBeforeInput={handleOnlyDgit}
                    maxLength={20}
                    // iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                    placeholder={'Enter Account Number'}
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>

            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                {/* <Form.Item
                  label={'Bank Name :'}
                  rules={required}
                  // required
                  name="bankName"
                  className="fieldTitle"
                >
                  <Select
                    size="large"
                    onChange={() => handleChange()}
                    placeholder="Select Bank"
                    disabled={!isEditable}
                  >
                    {bankNameList.map((item: any, index: any) => (
                      <Option key={item.bankName + index} value={item.bankName}>
                        {item.bankName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item> */}

                <Form.Item
                  label={'Bank Name :'}
                  // Rules can be removed since it is auto-filled
                  name="bankName"
                  className="fieldTitle"
                >
                  <Input
                    value={bankName1} // bankName1 should be populated from the IFSC lookup logic
                    readOnly={true} // Set the input field to read-only
                    style={{
                      border: '1px solid #dcdcdc',
                      backgroundColor: '#f5f5f5', // Optionally set a background color to indicate it is not editable
                    }}
                    placeholder="Bank Name"
                  />
                </Form.Item>
              </div>
            </div>

            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'Account Holder Name:'}
                  // required
                  name="accountHolderName"
                  className="fieldTitle"
                  rules={required}
                // rules={[
                //   ...required,
                //   {
                //     pattern: /^[a-zA-Z0-9\s.'-]+$/, // Added 0-9 for numeric characters
                //     message: 'Account Holder Name can only include letters, numbers, spaces, periods (.), or apostrophes (\')',
                //   },
                // ]}

                >
                  <Input
                    placeholder={'Enter Account Holder Name'}
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                {/* <Form.Item
                  label={'Branch Name:'}
                  // required
                  name="branchName"
                  className="fieldTitle"
                  rules={required}
                >
                  <Input
                    placeholder={'Enter Branch Name'}
                    style={{ border: '1px solid #dcdcdc' }}
                    readOnly={!isEditable}
                  />
                </Form.Item> */}

                <Form.Item
                  label={'Branch Name:'}
                  // Rules can be removed since it is auto-filled
                  name="branchName"
                  className="fieldTitle"
                >
                  <Input
                    value={branchName} // branchName should be populated from the IFSC lookup logic
                    readOnly={true} // Set the input field to read-only
                    style={{
                      border: '1px solid #dcdcdc',
                      backgroundColor: '#f5f5f5', // Optionally set a background color to indicate it is not editable
                    }}
                    placeholder="Branch Name"
                  />
                </Form.Item>
              </div>
            </div>

            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'Account Type :'}
                  name="accountType"
                  initialValue={'savings'}
                  // required
                  rules={required}
                  className="fieldTitle"
                >
                  <Radio.Group size="large" value={'savings'} defaultValue={'savings'}>
                    <Radio value="savings">
                      <p style={{ fontSize: '16px', fontWeight: '400' }}>Savings</p>
                    </Radio>
                    <Radio value="current">
                      <p style={{ fontSize: '16px', fontWeight: '400' }}>Current</p>
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                // marginTop: '20px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  marginBottom: '20px',
                }}
              >
                <Form.Item name={'isEditable'} label={'Set Editable:'} initialValue={true}>
                  <Checkbox
                    defaultChecked
                    style={{
                      fontSize: '14px',
                      backgroundColor: '#2c9897',
                      color: 'white',
                      padding: '5px 8px',
                      marginLeft: '40px',
                    }}
                    onChange={(e) => {
                      form.setFieldValue('isEditable', e.target.checked),
                        setIsEditable(e.target.checked);
                    }}
                  >
                    Is Editable
                  </Checkbox>
                </Form.Item>
              </div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
